import { z } from 'zod';

export const UserId = z.string().regex(/^[\dA-Z]{28,36}$/);

// eslint-disable-next-line no-redeclare
export type UserId = z.infer<typeof UserId>;
